// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","root":"Header_root__jiUBv","CodeMirror":"Header_CodeMirror__9w6Hf"};